export function slugify(str: string | undefined | null): string {
  if (!str) return ""
  return String(str)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

export function computeVariantId(size: string, color: string): string {
  return `${slugify(size)}-${slugify(color)}`
}

export function getVariantPrice(basePrice: number, priceModifier?: number): number {
  return Math.max(0, Math.round((basePrice + (priceModifier || 0)) * 100) / 100)
}

export function getImagesForColor(
  productImages: string[] | undefined,
  variantColors:
    | {
        name: string
        hex: string
        images?: string[]
        slug?: string
      }[]
    | undefined,
  color: string | null | undefined,
): string[] {
  if (!color || !variantColors || variantColors.length === 0) {
    return productImages && productImages.length > 0 ? productImages : []
  }
  const target = variantColors.find((c) => slugify(c.name) === slugify(color))
  const images = target?.images && target.images.length > 0 ? target.images : productImages
  return images || []
}

export function findVariantBySelection<
  V extends { size: string; color: string; id?: string; stock?: number; priceModifier?: number; colorHex?: string }
>(variants: V[] | undefined, size: string | null | undefined, color: string | null | undefined): V | undefined {
  if (!variants || !size || !color) return undefined
  const s = slugify(size)
  const c = slugify(color)
  return variants.find((v) => slugify(v.size) === s && slugify(v.color) === c)
}

export function generateMatrixVariants(
  sizes: { label: string; dimensions?: { length?: number; width?: number; height?: number } }[],
  colors: { name: string; hex: string }[],
  existing?: {
    id: string
    size: string
    color: string
    colorHex?: string
    stock: number
    priceModifier?: number
    sku?: string
    isActive?: boolean
  }[],
) {
  const map = new Map<string, (typeof existing)[number]>()
  for (const v of existing || []) {
    map.set(`${slugify(v.size)}|${slugify(v.color)}`, v)
  }

  const combinations: (typeof existing)[number][] = []
  for (const s of sizes) {
    for (const c of colors) {
      const key = `${slugify(s.label)}|${slugify(c.name)}`
      const prev = map.get(key)
      combinations.push(
        prev || {
          id: `${slugify(s.label)}-${slugify(c.name)}`,
          size: s.label,
          color: c.name,
          colorHex: c.hex,
          stock: 0,
          priceModifier: 0,
          isActive: true,
        },
      )
    }
  }
  return combinations
}